import React from "react";
import {
  getJobs,
  getJobIndustryFilter,
  getJobTypeFilter,
} from "../jobsSelectors";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { openModal } from "../../../app/common/modals/modalReducer";
import { MOBILE_JOB_FILTERS_MODAL } from "../../../app/common/modals/ModalManager";

export default function MobileJobFilterButton() {
  const dispatch = useDispatch();

  const { filters } = useSelector((state) => getJobs(state));

  const typeToFilter = getJobTypeFilter(filters);
  const industryToFilter = getJobIndustryFilter(filters);
  const filtersList = [typeToFilter, industryToFilter];
  const filtersSelectedCount = filtersList.filter(
    (i) => i !== undefined
  ).length;

  return (
    <Button
      className={`overwrite-button map-filters-button-mobile ${
        filtersSelectedCount > 0
          ? "active-mobile-float-button"
          : "mobile-float-button"
      }`}
      content={
        <div className="body-blue-text">
          Filters{" "}
          {`${
            filtersSelectedCount > 0 ? "(" + filtersSelectedCount + ")" : ""
          }`}
        </div>
      }
      onClick={() => {
        dispatch(openModal({ modalType: MOBILE_JOB_FILTERS_MODAL }));
      }}
    />
  );
}
